import React from "react";
import { InputRangeRow } from "./index";
// Used by Leesona 861 FC/Wax, Hacoba NSA-HS and Taining S41 machines

export default function YardsRow() {
   return (
      <InputRangeRow
         titleProp={"Yards"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={1}
         maxProp={9999999}
         propertyNameProp={"yards"}
         errorDialogueProp={"1-9,999,999 only"}
         floatProp={false}
      />
   );
}
